export default __webpack_public_path__ + "static/media/leg-press.e32e8d8d.jpg";